import { createApi } from '@reduxjs/toolkit/query/react';
import { AssignmentApi, AssignmentsFilter } from '../models';
import { API_INVENTORY_URL } from '@/utils';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { createBaseQueryWithReauth } from '@/services';

const inventoryAssignmentsService = createApi({
  reducerPath: 'inventoryAssignmentsService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/assignments`),
  tagTypes: ['InventoryAssignments', 'Assets'],
  endpoints: (builder) => ({
    getAssignments: builder.query<
      PaginatedResponse<AssignmentApi>,
      { filters?: AssignmentsFilter; paginated: PaginatedRequest }
    >({
      query: ({ filters, paginated }) => ({
        url: '',
        params: {
          ...(filters || {}),
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        },
      }),
      providesTags: ['InventoryAssignments'],
    }),
    getAssignment: builder.query<AssignmentApi, { assignmentId: string }>({
      query: ({ assignmentId }) => ({
        url: `/${assignmentId}`,
      }),
      providesTags: ['InventoryAssignments'],
    }),
    createAssignment: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['InventoryAssignments', 'Assets'],
    }),
    updateAssignment: builder.mutation({
      query: ({ assignmentId, body }) => ({
        url: `/${assignmentId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['InventoryAssignments', 'Assets'],
    }),
  }),
});

export default inventoryAssignmentsService;
export const { 
  useGetAssignmentsQuery, 
  useGetAssignmentQuery,
  useCreateAssignmentMutation, 
  useUpdateAssignmentMutation 
} = inventoryAssignmentsService;
